export default __webpack_public_path__ + "static/media/icon-check-circle.b347000a.svg";